import { useState } from "react";
import { faqList } from "@/mocks/gossip";

export default function Faq() {
  const [open, setOpen] = useState<number[]>(faqList.map((_, i) => i));

  const toggle = (idx: number) =>
    setOpen((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );

  return (
    <section id="faq" className="scroll-mt-24 w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="flex items-center gap-2 text-xs font-semibold tracking-wide text-primary-600">
              <i className="ri-question-line h-4 w-4 flex items-center justify-center text-accent-500" />
              FAQ · 常见问题
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              关于吃瓜的那些事
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于信息来源、删稿勘误、爆料投稿与报道边界，这里一次性讲清楚。
              我们相信：瓜要吃，也要吃得明明白白、有所克制。
            </p>
            <div className="mt-6 flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-question-answer-line h-6 w-6 flex items-center justify-center" />
              </span>
              <p className="text-xs leading-relaxed text-foreground-600">
                仍有疑问？可到底部“我要爆料”板块留言，编辑部会在工作日内逐条回复。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-8">
            {faqList.map((f, idx) => {
              const isOpen = open.includes(idx);
              return (
                <article
                  key={f.question}
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-200" : "border-background-200"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => toggle(idx)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex items-center gap-3">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-50 font-display text-sm font-bold text-primary-600">
                          {String(idx + 1).padStart(2, "0")}
                        </span>
                        <span className="font-label text-base font-semibold text-foreground-900">
                          {f.question}
                        </span>
                      </span>
                      <i
                        className={`ri-arrow-down-s-line h-5 w-5 flex items-center justify-center shrink-0 text-foreground-400 transition-transform ${isOpen ? "rotate-180 text-primary-500" : ""}`}
                      />
                    </button>
                  </h3>
                  {isOpen && (
                    <p className="border-t border-background-200 px-5 py-4 pl-14 text-sm leading-relaxed text-foreground-600">
                      {f.answer}
                    </p>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}